import { http } from ".."
import { askIAQuestionProps, updateAIProps } from "./aitutor-interface"



/**
 * Gets ais
 * @param data Object
 * @returns axios http response
 */
export const getAIs = () => {
  return http.get('/ai')
}

/**
 * Run updare ai assignment
 * @param data Object
 * @returns axios http response
 */
export const updateAI = (id: string, data: updateAIProps) => {
  return http.patch(`/ai-assignments/${id}`, data)
}

/**
 * Gets ai assignment
 * @param data Object
 * @returns axios http response
 */
export const getAIAssignment = (id: string) => {
  return http.get(`/ai-assignments/user/${id}`)
}

/**
 * Gets ai assignment join class check
 * @param data Object
 * @returns axios http response
 */
export const getAIAssignmentJoinClassCheck = (id: string) => {
  return http.get(`/ai-assignments/classes-check/${id}`)
}


/**
 * Gets ai assignment onboardings
 * @param data Object
 * @returns axios http response
 */
export const getAIAssignmentOnboarding = () => {
  return http.get(`/ai-assignments/onboarding`)
}

/**
 * Gets ai assignment incomplete tasks
 * @param data Object
 * @returns axios http response
 */
export const getAIAssignmentInCompleteTasks = () => {
  return http.get(`/ai-assignments/tasks/incomplete`)
}

/**
 * Ask ai question
 * @param data Object
 * @returns axios http response
 */
export const askIAQuestion = (data: askIAQuestionProps) => {
	return http.post(`/gpt`, data)
}

/**
 * Get ai chat
 * @param data Object
 * @returns axios http response
 */
export const getChatWithAi = () => {
  return http.get(`/chat/ai`)
}